var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthSavingsAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21350_8909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6063 21.5013C13.8948 21.7547 14.1927 22.0161 14.4991 22.2871C14.5012 22.2889 14.5033 22.2908 14.5054 22.2926L15.5247 23.1731C15.6613 23.2911 15.8308 23.35 16.0002 23.35C16.1697 23.35 16.3393 23.291 16.4758 23.1731L17.4949 22.2926C17.4971 22.2908 17.4991 22.289 17.5012 22.2871C19.519 20.5027 21.0318 19.1366 22.1263 17.8042C23.4046 16.2481 24 14.8411 24 13.3763C24 10.7262 21.9242 8.65039 19.2742 8.65039C18.0832 8.65039 16.9063 9.09888 16.0002 9.87631C15.0939 9.09883 13.9171 8.65039 12.726 8.65039C10.0759 8.65034 8 10.7262 8 13.3763C8 16.5796 10.2303 18.5376 13.6063 21.5013ZM13.0903 14.5454H15.03V12.6055H16.9699V14.5454H18.9097V16.4852H16.9699V18.425H15.03V16.4852H13.0903V14.5454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21350_8909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSavingsAccount);
export default __webpack_public_path__ + "static/media/health_savings_account.ac817c17bdfdfe37d26f00d512d02615.svg";
export { ForwardRef as ReactComponent };